import { LanguageEnum } from '@models/language.model.ts';

export interface SeriesRowDataProps {
  _id?: string;
  id?: string;
  title: { [key: string]: string };
  description: { [key: string]: string };
  backdrop?: string;
  poster?: string;
  genres?: any;
  date?: string;
}

export interface EpsiodeRowDataProps {
  id?: string;
  title: { [key: string]: string };
  description: { [key: string]: string };
  image?: string;
}

export interface EpisodeTableProps {
  selectedSerie: SeriesRowDataProps | null;
  language: LanguageEnum;
  setLanguage: (value: LanguageEnum) => void;
}

export interface SeriesModel extends Omit<SeriesRowDataProps, 'id'> {
  _id: string;
}

export interface EpisodeModel extends Omit<EpsiodeRowDataProps, 'id'> {
  _id: string;
}

export interface EditDialogSeriesFormProps {
  selectedItem: SeriesRowDataProps | null;
  handleClose: () => void;
  handleCreateOrUpdate: (row: any) => void;
  setCurrentDisplayTab: (value: string) => void;
  currentDisplayTab: string;
}

export interface EditDialogSeasonsFormProps {
  handleClose: () => void;
  onSave: (row: any) => void;
  selectedSeason?: any;
}

export interface SeriesDialogFormProps {
  selectedItem: SeriesRowDataProps | null;
  handleClose: () => void;
  onSave: (row: any) => void;
}

export enum SeriesTabsEnum {
  Details = 'details',
  Media = 'media'
}

export interface SeasonModel {
  title: { [key: string]: string };
  seasonNumber: number;
  id?: string;
}

export interface EpisodeFormProps {
  _id?: string;
  id?: string;
  title: { [key: string]: string };
  url: string;
  description: { [key: string]: string };
  image?: string;
  seasonId?: string;
}

export interface EpsiodeDialogFormProps {
  selectedItem: EpisodeFormProps | null;
  onSave: (row: any) => void;
}
